import { createTaskRepository } from './task';
import { createThreadRepository } from './thread';
import { createMessageRepository } from './message';
import { createTaskStatusRepository } from './task-status';
export function createAssistantReact(config) {
    const { client, repository } = config;
    const baseConfig = {
        client,
        repository,
    };
    return {
        task: createTaskRepository(baseConfig),
        taskStatus: createTaskStatusRepository(baseConfig),
        thread: createThreadRepository(baseConfig),
        message: createMessageRepository(baseConfig),
    };
}
//# sourceMappingURL=assistantReactProvider.js.map